<template>
        <v-card>
            <v-card-title>
                <span class="headline">Quick Create a Crop</span>
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="QuickCreateCrop">
                    <v-container v-if="arevarietiesloading">
                        <v-row>
                            <v-col cols="12" class="text-center pa-2">
                                <v-progress-circular
                                        :size="100"
                                        :width="7"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-container v-else>
                        <v-row >
                            <v-col class="pa-2" cols="12" sm="10" >
                                <v-autocomplete
                                        name="variety"
                                        label="Variety*"
                                        id="variety"
                                        v-model="selectedvariety"
                                        :items="varietyitems"
                                        item-text="name"
                                        item-value="id"
                                        return-object
                                        hint="What Variety/Cultivar is it?"
                                        required
                                        @input="GetCompleteTaxonomicInformation"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col v-if="completetaxonomicinfoloading" cols="12" class="text-center">
                                <v-progress-circular
                                        :size="100"
                                        :width="7"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </v-col>
                            <v-col v-else-if="completetaxonomicinfodisplay">
                                <ul style="list-style: none;">

                                    <li><b>Order: </b> {{completetaxonomicinfo.order_name}}</li>
                                    <li><b>Family: </b> {{completetaxonomicinfo.family_name}}</li>
                                    <li><b>Genus: </b> {{completetaxonomicinfo.genus_name}}</li>
                                    <li v-if="completetaxonomicinfo.variety_group_name"><b>Variety Group: </b> {{completetaxonomicinfo.variety_group_name}}</li>
                                    <li><b>Species: </b> {{completetaxonomicinfo.species_name}}</li>

                                </ul>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col class="pa-2" cols="12" sm="10" >
                                <v-text-field
                                        name="name"
                                        label="Name (optional)"
                                        id="name"
                                        v-model="cropname"
                                        hint="Name to give this crop, largely for your own use"
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-col cols="4" offset="5">
                            <v-btn @click="CloseCropQuickCreateDialog">
                                Cancel
                            </v-btn>
                            <v-btn type="submit" :loading="submitloading" color="primary">
                                Submit
                                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                            </v-btn>
                        </v-col>
                    </v-container>

                </form>
            </v-card-text>
        </v-card>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CropQuickCreate',

  data: () => ({
    errors: [],


    completetaxonomicinfodisplay: false,
    completetaxonomicinfoloading: false,
    completetaxonomicinfo: [],


    arevarietiesloading: false,
    varietyitems: [],

    selectedvariety: [],
    cropname: '',

    submitloading: false,


  }),

  methods: {
    GetAllVarieties() {
      this.selectedvariety = [];
      if (!this.varietieshavebeenfetched) {
        this.arevarietiesloading = true;
        return axios.get('barebones/list/varieties/')
          .then((response) => {
            this.varietyitems = response.data;
            this.varietieshavebeenfetched = true;
          })
          .then(() => {
            this.arevarietiesloading = false;
          });
      }
    },

    QuickCreateCrop() {
      const authheader = `Token ${this.$store.getters.token}`;
      this.submitloading = true;

      return axios.get('profile/saveddefaults/',
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          const cropdata = this.removeEmptyStrings({
            name: this.cropname,
            variety: this.selectedvariety.id,
            producer: this.$store.state.user.pk,
            growing_location: response.data.default_growing_location,
            growing_information: response.data.default_growing_information,
          });
          return axios.post('baseproduct/create/', cropdata,
            {
              headers: {
                Authorization: authheader,
              },
            });
        })
        .then(() => {
          this.submitloading = false;
        })
        .then(() => {
          this.selectedvariety = [];
          this.cropname = '';
          this.completetaxonomicinfo = [];
        })
        .then(() => {
          this.$emit('crop-created');
        })
        .then(() => {
          if (!this.$store.getters.error) {
            this.$parent.$emit('alertemitted', { alert_icon: 'check_circle', alert_color: 'success', alert_message: 'Crop Created!' });
          }
        });
    },

    CloseCropQuickCreateDialog() {
      this.$emit('close-dialog');
    },
    GetCompleteTaxonomicInformation() {
      this.completetaxonomicinfo = [];
      const varietyslug = this.selectedvariety.slug;
      this.completetaxonomicinfoloading = true;
      this.completetaxonomicinfodisplay = false;
      axios.get(`taxonomic_information/by/variety/${varietyslug}/`)
        .then((response) => {
          this.completetaxonomicinfo = response.data;
        })
        .then(() => {
          this.completetaxonomicinfoloading = false;
          this.completetaxonomicinfodisplay = true;
        });
    },
    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },
  },
  created() {
    this.GetAllVarieties();
  },
};
</script>

<style scoped>

</style>
